<template>
    <el-row class="container_self table_parent">
        <h3>域名实时状态   <span class="timers">本次查询已更新 {{times}} 次</span></h3>
        <el-row>
            <span>刷新频率</span>
            <el-select v-model="interval" @change="intervalChange" size="mini" style="margin:0 0 10px 5px">
                <el-option label="1 分钟" :value="60000"></el-option>
                <el-option label="5 分钟" :value="300000"></el-option>
                <el-option label="10 分钟" :value="600000"></el-option>
                <el-option label="30 分钟" :value="1800000"></el-option>
            </el-select>
        </el-row>
        <el-table :data="domainStatus" style="width: 100%" v-loading="loading" element-loading-text="查询中，请稍后">
            <el-table-column label="在线状态" align="center">
                <template slot-scope="scope">
                    <div  v-if="scope.row.online"><span class="online little-circle"></span>在线</div>
                    <div v-else> <span class="offline little-circle"></span>离线</div>
                </template>
            </el-table-column>
        <el-table-column label="域名" prop="dm" align="center"></el-table-column>
        <el-table-column prop="responseStatus" label="HTTP状态" align="center"></el-table-column>
        <el-table-column label="其他" align="center">
            <template slot-scope="scope">
                <span v-if="scope.row.extra" :class="{'red-text': scope.row.extra.includes('异常')}">{{ scope.row.extra }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="responseTime" label="响应时间" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
    </el-table>
    </el-row>
</template>
<style>
    .red-text{
        color:rgb(255,0,0);
    }
</style>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
    export default {
        data(){
            return{
                domainStatus:[],
                statusQuery:{
                    extra:"",
                    online:"",
                    responseStatus:""
                },
                timer: null,
                times:0,
                loading:false,
                interval:300000
            }
        },
        methods:{
            getStatusList(params){
                this.loading=true;
                axiosGet('/api/domains/status',params).then(res=>{
                    if(res.code==0){
                        this.times+=1;
                        this.domainStatus=res.data;
                        this.loading=false;
                    }else{
                        this.loading=false;
                    }
                })
            },
            startPolling() {
                console.log(this.interval)
                this.timer = setInterval(() => {
                    this.getStatusList(this.statusQuery);
                }, this.interval); // 每隔五分钟执行一次
            },
            stopPolling() {
                clearInterval(this.timer); // 清除定时器
            },
            intervalChange(val){
                this.stopPolling();
                this.startPolling();
            }
        },
        mounted(){
            this.getStatusList(this.statusQuery);
            this.startPolling(); // 开始定时器
        },
        beforeDestroy() {
            this.stopPolling(); // 在组件销毁之前清除定时器
        }
    }
</script>

<style>
    .timers{
        float: right;
        font-size:16px;
        font-weight: normal;
    }
    .little-circle{
        width:5px;
        height:5px;
        border-radius: 100%;
        display: inline-block;
        margin-right: 10px;
    }
    .online{
        background-color: rgb(134, 212, 16);
    }
    .offline{
        background-color: gray;
    }
</style>


// WEBPACK FOOTER //
// src/components/view/domainManager/status.vue